import { isUndefined } from 'lodash-es';

import { ChartOverlaysBorder } from '../../../core/components/overlays/ChartOverlaysBorder.js';
import { useHistogramYScales } from '../../hooks/useHistogramYScales.js';

export const HistogramChartOverlaysBorder = () => {
  const [leftScale, rightScale] = useHistogramYScales();

  return (
    <ChartOverlaysBorder
      left={!isUndefined(leftScale)}
      right={!isUndefined(rightScale)}
      bottom
    />
  );
};
